import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MissingItems from './components/MissingItems';

const missingItems = (props,{ t }) => (
  <Container>
    <MissingItems {...props} />
  </Container>
);

missingItems.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(missingItems);
